exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n[data-v-7ba5bd90] .el-table__fixed-right .el-table__fixed-body-wrapper {\n  background-color: #fff !important;\n}\n", ""]);

// exports
